module.exports = "https://coursera_assets.s3.amazonaws.com/images/ddb38b46cf34b63127156d933a531d40.png";